import React from 'react';
import { ToggleButtonGroup, ToggleButton, Tooltip, Stack } from '@mui/material';

const TimeRangeSelector = ({ timeRange, handleTimeRangeChange, timeRanges, loading }) => {
  return (
    <Stack direction="row" justifyContent="flex-end" alignItems="center">
      <ToggleButtonGroup
        value={timeRange}
        exclusive
        onChange={handleTimeRangeChange}
        aria-label={'Time Range'}
        size="small"
      >
        {timeRanges.map((range) => (
          <Tooltip key={range.value} title={range.tooltip || ''} disableHoverListener={!range.tooltip} arrow>
            <span style={{ display: 'inline-flex' }}>
              <ToggleButton
                value={range.value}
                disabled={loading}
                size="small"
                sx={{ px: 1.5, py: 0.75, fontSize: 12, fontWeight: 600 }}
              >
                {range.label}
              </ToggleButton>
            </span>
          </Tooltip>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
};

export default TimeRangeSelector;
